import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getAvgSurcharge = {
  name: "getAvgSurcharge" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
